<template>
<v-form>
  <v-card flat >
    <v-card-title class='overline' >
      {{ $t('titles.patientinfo') }}
      <v-spacer></v-spacer>
      <!-- <v-btn
        @click="undoSetPatientInformation"
        v-if='usePatientDataBtnClicked' outline small >
        {{ $t('buttons.undo') }}
      </v-btn> -->
      <v-btn outline small
        @click="setPatientInformation(patientData, overwrite=true)" >
        {{ $t('buttons.usecontactinfo') }}
      </v-btn>
    </v-card-title>
    <v-card-text>
      <!-- <object-list-view
        v-if='usePatientInformation'
        v-model='medicalaid'
        :touch='touch'
        :fields="formsets.patient" >
      </object-list-view> -->
      <object-form
        v-model='medicalaid'
        :touch='touch'
        :fields="formsets.patient" >
      </object-form >
    </v-card-text>
  </v-card>

  <v-card flat class='mt-2' >
    <v-card-title class='overline' >
      {{ $t('titles.medicalaid') }}
    </v-card-title>
    <v-card-text>
      <object-form
        v-model='medicalaid'
        :touch='touch'
        :fields="formsets.medical_aid"
        :field-configs='formsets.medical_aid_config' >
        <v-checkbox v-model='medicalaid.is_dependent' slot='is_dependent' label='Patient is a dependant' >
        </v-checkbox>
        <template slot='name-after' >
          <span class='overline' >Quick picks</span>
          <v-chip v-for='pick in quickpicks' :key='pick'
            @click='medicalaid.name = pick'
            class='v-chip--x-small' outline >{{pick}}</v-chip>
        </template>
      </object-form >
      <div v-if = 'medicalaid.is_dependent' >
        <v-subheader class='pl-0' >Main member details</v-subheader>
        <object-form
          v-if='medicalaid.is_dependent'
          v-model='medicalaid' :touch='touch'
          :fields="formsets.main_member" >
        </object-form >
      </div>
    </v-card-text>
  </v-card>
</v-form>
</template>

<script>
import ObjectForm from './ObjectForm'
import ObjectListView from './ObjectListView'
import MedicalAidPicker from '@/components/pickers/MedicalAidPicker'
import vue from 'vue'

export default {
  name: 'MedicalAidDetails',
  components: { ObjectListView, ObjectForm, MedicalAidPicker },
  props: {
    value: { type: Object },
    patientData: { type: Object },
    touch: { type: Number, default: 0 },
    usePatientInformation: { type: Boolean, default: true }
  },
  data () {
    return {
      cachedMedicalaid: {},
      usePatientDataBtnClicked: false,
      medicalaid: {},
      formsets: {
        patient: ['patient_first_name', 'patient_last_name', 'patient_id_number'],
        medical_aid: ['name', 'scheme', 'number', 'is_dependent'],
        medical_aid_config: {
          'name': {
            hint: 'Medical aid name. e.g. Discovery Health',
            persistentHint: true
          },
          'number': {
            hint: 'Medical aid number. e.g. 122345677',
            persistentHint: true
          }
        },
        main_member: ['member_first_name', 'member_last_name', 'member_id_number']
      },
      quickpicks: ['Discovery Health', 'Momentum Health', 'MediHelp', 'GEMS', 'Bankmed', 'Bonitas', 'CAMAF', 'Profmed']
    }
  },
  mounted () {
    if (this.value) {
      this.medicalaid = this.value
    }
    // if (this.usePatientInformation === true) {
    //   this.setPatientInformation(this.patientData)
    // }
  },
  computed: {
    isMainMember () {
      return this.medicalaid.is_dependent === false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.medicalaid = this.value
        }
      }
    },
    medicalaid () {
      this.$emit('input', this.medicalaid)
    },
    patientData () {
      if (this.usePatientInformation === true) {
        this.setPatientInformation(this.patientData)
      }
    },
    usePatientInformation () {
      if (this.usePatientInformation === true) {
        this.setPatientInformation(this.patientData)
      }
    },
    touch () {
      this.usePatientDataBtnClicked = false
      if (this.value) {
        this.medicalaid = this.value
      }
    }
  },
  methods: {
    undoSetPatientInformation () {
      let data = this.cachedMedicalaid
      vue.set(this.medicalaid, 'patient_first_name', data.patient_first_name)
      vue.set(this.medicalaid, 'patient_last_name', data.patient_last_name)
      vue.set(this.medicalaid, 'patient_id_number', data.patient_id_number)
      this.usePatientDataBtnClicked = false
    },
    setPatientInformation (data, overwrite = false) {
      if (overwrite === true) {
        this.cachedMedicalaid = JSON.parse(JSON.stringify(this.medicalaid))
        this.usePatientDataBtnClicked = true
      }
      if (data) {
        if (data.first_name) {
          if (overwrite || !this.medicalaid.patient_first_name) {
            vue.set(this.medicalaid, 'patient_first_name', data.first_name)
          }
        }
        if (data.last_name) {
          if (overwrite || !this.medicalaid.patient_last_name) {
            vue.set(this.medicalaid, 'patient_last_name', data.last_name)
          }
        }
        if (data.id_number) {
          if (overwrite || !this.medicalaid.patient_id_number) {
            vue.set(this.medicalaid, 'patient_id_number', data.id_number)
          }
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        titles: {
          accountperson: 'Person responsible for account',
          patientinfo: 'Patient information',
          medicalaid: 'Medical aid details'
        },
        buttons: {
          undo: 'Undo',
          usecontactinfo: 'use contact info'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// MedicalAidDetails.vue?73612d6a